module.exports = __webpack_public_path__ + "static/media/HCMM954.90a9ec92.jpg";